    import { Poppins, Quicksand } from 'next/font/google'
    import Image from 'next/image'
    import React, { Component } from 'react'
    import { ImStarFull, ImStarHalf } from "react-icons/im";
    import Form from '../education-form'
import Link from 'next/link'
    const popins = Poppins({weight:"500",subsets:['latin']})
    const extrapopins = Poppins({weight:"600", subsets:['latin']});
    const quickSand = Quicksand({weight:"400",subsets:['latin']})
    export default class NewMainsec extends Component {
    
        constructor(props){
            super(props);
            this.state={
                showForm: false,
            };
            this.formRef = React.createRef();
        }
    
    handleFormPopup=()=>{
    this.setState({showForm:true});
    document.addEventListener('mousedown',this.handleClickOutside);
    }
    
    handleCloseForm =()=>{
        this.setState({showForm:false})
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClose=()=>{
        this.setState({showForm:false}) 
    }
    handleClickOutside=(event)=>{
        if(this.formRef.current && !this.formRef.current.contains(event.target)){
            this.handleCloseForm();
        }
    }
    // // Function to render stars based on the rating

    // renderStars = () => {
    //     const { rating } = this.props; // Use the rating prop here
    //     const stars = [];
    //     for (let i = 1; i <= 5; i++) {
    //         stars.push(
    //             <span key={i} style={{ color: i <= rating ? '#FFD700' : '#', fontSize: '1.5rem' }}>
    //                 ★
    //             </span>
    //         );
    //     }
    //     return stars;
    // };

    renderStars = () => {
        const { rating } = this.props; // Use the rating prop here
        const stars = [];
        const fullStars = Math.floor(rating); // Number of full stars
        const halfStar = rating % 1; // Fractional part of the rating
        
        for (let i = 1; i <= 5; i++) {
            if (i <= fullStars) {
                // Render full star
                stars.push(
                    <ImStarFull key={i} style={{ color: '#000000', fontSize: '0.6875rem',paddingLeft:"0.3125rem" }} />
                );
            } else if (i === fullStars + 1 && halfStar >= 0.5) {
                // Render half star
                stars.push(
                    <ImStarHalf key={i} style={{ color: '#000000', fontSize: '0.6875rem',paddingLeft:'0.3125rem' }} />
                );
            } else {
                // Render empty star
                stars.push(
                    <ImStarFull  key={i} style={{ color: '#ccc', fontSize: '0.6875rem',paddingLeft:'0.3125rem'  }} />
                );
            }
        }
        return stars;
    };


    render() {
 
        return (
            <>
    <section className='course-bg'>
        <div className='container'>
    <div className='pdt50 pdtb20 df gap16 mfdc fac fjc'>
        {/* Content Column */}
    <div className=''>
    <h1 className={`fs-40 cb lh5 mfs-22  pdt20 mpdt10  ${extrapopins.className}`}>{this.props.title} {this.props.location1}</h1>
  <div className='df fac'>
    <div className="rating ">
    {this.renderStars()}
    </div>
    <p className={`fs-14 pdl5 ${popins.className}`}>{this.props.rating} | <span > {this.props.students}+ Students</span> </p>
    </div>
    <p className={`fs19 lnh41 cb mt32 mfs14 mlhs20 mmt12 tal ${popins.className}`}>
    {this.props.intro}
    </p>

    <div className='df gap20 mt24 mfw'>
        {/* Durations */}
      <div className=''>
        <div className='df fac gap8'>
            <Image src={"/course-img/durations.svg"} width={10} height={10} alt='Duraiton-Icon' loading='lazy'/>
           <p className={`fs-14 ${popins.className}`}>Durations : </p>
        </div>
        <p className={`fs-12 tac ${popins.className}`}>{this.props.durations} days</p>
      </div>

       {/* Students */}
      <div className=''>
        <div className='df fac gap8'>
            <Image src={"/course-img/user.svg"} width={10} height={10} alt='User-Icon' loading='lazy'/>
           <p className={`fs-14 ${popins.className}`}>Students Enrolled: </p>
        </div>
        <p className={`fs-12 tac ${popins.className}`}>{this.props.students}+ Students</p>
      </div>

             {/* Course Type */}
             <div className=''>
        <div className='df fac gap8'>
            <Image src={"/course-img/course-type.svg"} width={10} height={10} alt='User-Icon' loading='lazy'/>
           <p className={`fs-14 ${popins.className}`}>Course Type: </p>
        </div>
        <p className={`fs-12 tac ${popins.className}`}>Online / Offline</p>
      </div>


    </div>

    <div className='className={`df   mt32 mmt20 `}'>
        

<button onClick={this.handleFormPopup} className={` enrl-btn   ${extrapopins.className}`}>Enroll Now</button>


<button className={`dwnld-btn ${popins.className}`} >
<Link href='tel:7825888899' className='cb link-btn'>Get a Free Demo</Link>
</button>

</div>

    </div>

    {/* Image Column */}

    <div className={`mdn`}>
        <Image src={`/course/${this.props.img}.webp`} className="br20" alt={`${this.props.title} ${this.props.location1} Course-Image`} width={502} height={330} loading='lazy'/>        
 </div>

 <div className={`dn mdb tac`}>
        <Image src={`/course/${this.props.img}.webp`} className="br20" alt={`${this.props.title} ${this.props.location1} Course-Image`} width={290} height={230} loading='lazy'/>        
 </div>

    </div>
    </div>
    </section>
    {this.state.showForm && <div ref={this.formRef}><Form close={this.handleClose} closeForm={this.handleCloseForm}/></div>}
    <style jsx>
        {`

        .course-bg{
            // background-image: url('/course-img/course-head-bg.webp');
            background: linear-gradient(to right, rgba(253, 187, 57, 0.58), rgba(251, 188, 59, 0.27));
            width:100%;
            height: auto;
            background-size: contain;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .dwnld-btn{              
            border-radius: 8px;
            padding: 15px 33px 15px 33px;
            margin-left:20px;
            background-color: transparent;
            cursor: pointer;
            font-size: 19px;
            line-height: 17.5px;
            letter-spacing: 1.25px;
            border: 2px solid #000000;
            transition: all 0.4s linear;
        
        }
        .link-btn:hover{
        color: #FFFFFF !important;
        }
        .dwnld-btn:hover{
            background-color: #000000;
            color: #FFFFFF !important;            
        }

        .enrl-btn{        
            border-radius: 8px;
            padding: 15px 36px 15px 36px;
            border: 2px solid #FFFFFF;
            box-sizing: border-box;
            background-color: #181613;
            cursor: pointer;
            font-size: 19px;
            letter-spacing: 1.25px;
            line-height: 17.5px;
            color: #ffffff;      
            transition: all 0.4s linear;
        }
        .enrl-btn:hover{
            background-color: #FFFFFF;
            color: #FFA900;
            border: 2px solid #000000;
        }
        @media only screen and (max-width: 1023px){
        .course-bg{
            //  background-image: url('/course-img/course-head-bg.webp');
background: linear-gradient(to right, rgba(253, 187, 57, 0.58), rgba(251, 188, 59, 0.27));
            width:100%;
            height: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
           
            background-size: 100% 100%;
        }
        .dwnld-btn{                
            border-radius: 15px;
            padding: 5px 12px 5px 12px;
            border: 0.25px solid #000000;
            color: #FFFFFF;
            cursor: pointer;
            font-size: 12px;
            line-height: 10.5px;
            letter-spacing: 0.25px;
            background-color: transparent;
        }
        .enrl-btn{        
            border-radius: 15px;
            padding: 5px 12px 5px 12px;
            border: 0.25px solid #FFFFFF;
            box-sizing: border-box;
        background-color: #181613;
            cursor: pointer;
            font-size: 12px;
            letter-spacing: 1.25px;
            line-height: 14.5px;
            color: #ffffff;      
        }
        }
        `}
    </style>
    </>
        )
    }
    }